import * as React from 'react';
import clsx from 'clsx';
import { Box, BoxProps, makeStyles, createStyles } from '@bb-ui/react-library';
import { useExperience } from 'contexts/ExperienceContext';

export interface ContentWrapProps extends BoxProps {
  unbounded?: boolean;
}

export const useStyles = makeStyles(() =>
  createStyles({
    '@keyframes fadeInUp': {
      from: {
        opacity: 0,
        transform: 'translateY(8px)',
      },
      to: {
        opacity: 1,
        transform: 'translateY(0)',
      },
    },
    root: {
      width: '100%',
      animation: '$fadeInUp 0.3s ease-out',
      paddingLeft: '40px',
      paddingRight: '40px',
      boxSizing: 'border-box',
    },
    rootClassic: {
      width: '100%',
    },
  }),
);

export const ContentWrap: React.FC<ContentWrapProps> = (props) => {
  const { className, unbounded, ...other } = props;

  const classes = useStyles(props);
  const { isClassic } = useExperience();

  return (
    <Box
      className={clsx(isClassic ? classes.rootClassic : classes.root, className)}
      maxWidth={isClassic && !unbounded ? '1000px' : undefined}
      marginX={isClassic ? 'auto' : undefined}
      {...other}
    />
  );
};

export default ContentWrap;
